import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Icon from 'components/Icon'
import ProgressBar from 'components/ProgressBar'
import { bulkInvitesStatusSelector, setIsMinimizing } from '../attendeeSlice'

const S = {
    Wrapper: styled.div`
        position: fixed;
        z-index: 99;
        right: 20px;
        bottom: 20px;
        width: 300px;
        padding: 30px 16px 14px 16px;
        border-radius: 5px;
        background: white;
        border: 1px solid rgba(0, 0, 0, 0.03);
        box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
    `,
    CloseIcon: styled(Icon)`
        position: absolute;
        top: 2px;
        right: 2px;
    `,
}

const MinimizeBulkInvitesProgress = () => {
    const dispatch = useDispatch()
    const progress = useSelector(bulkInvitesStatusSelector)
    const isCompleted = progress.completed >= progress.total

    if (!progress.isMinimizing) {
        return <div />
    }

    return (
        <S.Wrapper>
            {isCompleted && (
                <S.CloseIcon icon="close" size={18} onClick={() => dispatch(setIsMinimizing(false))} />
            )}
            <ProgressBar
                progress={progress}
                isMinimizing
            />
        </S.Wrapper>
    )
}

export default MinimizeBulkInvitesProgress
